import { Box, Button, CircularProgress, FormControl, Grid, IconButton, Paper, TextField, Tooltip, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';

import { Link, useNavigate } from 'react-router-dom';

import { useEffect, useRef, useState } from 'react';

import { format } from 'date-fns';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';

import configUrls from '../../../config/configUrls';
import { useDeleteAtribuirBlocoMutation, useGetProcessoBlocosQuery } from '../processoApiSlice';
import { ProcessoBlocoList } from '../../../types/processo/ProcessoBlocoList';
import { ISprocessoBloco, ProcessoBloco } from '../../../types/processo/ProcessoBloco';
import { GridDeleteIcon } from '@mui/x-data-grid';
import ConfirmDialogList from '../../../components/ConfirmDialogList';

export const ProcessoBlocoListForm = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // Hook para navegação

  const [atribuicoes, setAtribuicoes] = useState<ProcessoBlocoList[]>([]);

  const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
  useEffect(() => {
    if (!processoSelecionado) {
      alert('Nenhum processo selecionado');
      window.location.href = configUrls.PROCESSO_LIST_RT;
    }
  }, [processoSelecionado]);

  /**Delete grid */
  const [toDelete, setToDelete] = useState<ProcessoBloco>(ISprocessoBloco);
  const [openConfirmExcluir, setOpenConfirmExcluir] = useState(false);
  const [deleteMutation, { error: errorMutation, isLoading, isSuccess }] = useDeleteAtribuirBlocoMutation();

  /**fim delede grid */

  /*SEARCH*/

  const [search, setSearch] = useState<string>('');
  const [debouncedSearch, setDebouncedSearch] = useState<string>('');
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const cursorPosition = useRef<number>(0);

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    cursorPosition.current = inputRef.current?.selectionStart || 0;
    setSearch(e.target.value);
  };

  useEffect(() => {
    // Limpar o timeout anterior
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Configurar o timeout para o debounce
    debounceTimeout.current = setTimeout(() => {      
      setDebouncedSearch(search);
    }, 700); // Tempo de debounce (700ms)

    // Limpar o timeout quando o componente for desmontado ou o efeito for reiniciado
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [search]); // Dependência do useEffect: quando o 'search' mudar

  /*FIM SEARCH*/

  const { data, isFetching, error } = useGetProcessoBlocosQuery({ id: processoSelecionado?.id ?? '', search: debouncedSearch });

  useEffect(() => {
    if (data) {
      setAtribuicoes(data);
    }
    if (error) {
      enqueueSnackbar('Atribuições não encontradas!', { variant: 'error' });
    } else if (isFetching) {
      enqueueSnackbar('Buscando registros...', { variant: 'info' });
    }

    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current?.setSelectionRange(cursorPosition.current, cursorPosition.current);
    }
  }, [data, error, isFetching, enqueueSnackbar]);

  const headerGerados = (
    <Typography variant="body2" color="textSecondary">
      Bloco(s) encontrado(s): {atribuicoes.length}
    </Typography>
  );

  const renderData = (rowData: ProcessoBlocoList) => {
    const dataCriacao = rowData.dataHora ? format(rowData.dataHora, 'dd/MM/yyyy HH:mm:ss') : 'Data não disponível';
    return (
      <Typography color="secondary" variant="body2">
        {dataCriacao}
      </Typography>
    );
  };

  const renderUsuario = (rowData: ProcessoBlocoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.usuario?.nome || 'Usuário não disponível'}
    </Typography>
  );
  const renderObservacao = (rowData: ProcessoBlocoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.observacao || ''}
    </Typography>
  );
  const renderBloco = (rowData: ProcessoBlocoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.bloco.nome || ''}
    </Typography>
  );

  const renderAction = (rowData: any) => {
    return (
      <Box sx={{ display: 'flex', gap: '8px' }}>
        <Tooltip title="Excluir">
          <IconButton color="secondary" aria-label="delete" onClick={() => handleExcluirtClick(rowData)}>
            <GridDeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

  const handleExcluirtClick = (rowData: any) => {
    setToDelete(rowData);
    setOpenConfirmExcluir(true);
  };
  const handleCloseDialog = () => {
    setOpenConfirmExcluir(false);
  };
  const handleConfirm = async () => {
    setOpenConfirmExcluir(false);
    await deleteMutation({ id: toDelete.id ? toDelete.id : '' });
  };

  useEffect(() => {
    if (isSuccess) {
      enqueueSnackbar('Registro deletado com sucesso!', { variant: 'success' });
      // fetchDados();
    }
    if (errorMutation) {
      enqueueSnackbar('Registro não deletado!', { variant: 'error' });
    }
  }, [isSuccess, errorMutation]);

  if (isFetching) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <ConfirmDialogList
        open={openConfirmExcluir}
        handleClose={handleCloseDialog}
        title="Confirmar Ação"
        text={['Você tem certeza de que deseja excluir esse Bloco?', toDelete.observacao ? toDelete.observacao : '']}
        handleDelete={() => {
          handleConfirm(); // Chama a função handleConfirm
          setOpenConfirmExcluir(false); // Fecha o diálogo
        }}
      />

<Paper sx={{ width: '100%', height: '100vh', padding: '12px', display: 'flex', flexDirection: 'column' }}>
        <Grid container padding={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Box display="flex" justifyContent="space-between" mb={2}>
                <Box display="flex">
                  <Typography color="secondary" variant="h6" gutterBottom>
                    Blocos do processo: {processoSelecionado?.numeroProcesso}
                  </Typography>
                </Box>

                <Box display="flex" justifyContent="flex-end" gap={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      navigate(configUrls.PROCESSO_BLOCO_CREATE_RT);
                    }}
                  >
                    Novo
                  </Button>

                  <Button variant="contained" onClick={() => navigate(-1)} color="secondary">
                    Voltar
                  </Button>
                </Box>
              </Box>
            </FormControl>
          </Grid>

          <Grid item xs={12} mt={5}>
            <FormControl fullWidth>
              <TextField label="Digite para pesquisar" name="nome" onChange={handleChangeSearch} size="small" inputProps={{ maxLength: 100 }} value={search} inputRef={inputRef} />
            </FormControl>
          </Grid>
        </Grid>

        <DataTable
          value={atribuicoes}
          paginator
          rows={25}
          showGridlines={true}
          size="small"
          columnResizeMode="expand"
          resizableColumns
          dataKey="id"
          header={headerGerados}
          className="custom-datatable"
        >
          <Column header="Data" body={renderData} sortable style={{ width: '15%' }} />
          <Column header="Usuário" body={renderUsuario} sortable style={{ width: '15%' }} />
          <Column header="Bloco" body={renderBloco} sortable style={{ width: '70%' }} />
          <Column header="Observação" body={renderObservacao} sortable style={{ width: '70%' }} />
          <Column header="Deletar" body={renderAction} sortable style={{ width: 'auto' }} />
        </DataTable>
      </Paper>
    </>
  );
};
